import React, {useRef} from "react";
import styled from "styled-components";
import theme from "../../style/theme";
import {IssueStatus} from "../../types/action/issue-status";
import {DeliveryGroupType} from "../../types/schedule/delivery-group-type";
import {DeliveryInGroup} from "../../types/schedule/delivery-in-group";
import {Schedule} from "../../types/schedule/schedule";
import Icon from "../icon/Icon";
import RecompleteIcon from "../icons/\bRecompleteIcon";
import CommentLineIcon from "../icons/CommentLineIcon/CommentLineIcon";
import DropOffLocationIcon from "../icons/DropOffLocationIcon/DropOffLocationIcon";
import MemoDropOffLineIcon from "../icons/MemoDropOffLineIcon";
import MemoPickUpLineIcon from "../icons/MemoPickUpLineIcon";
import PickUpLocationIcon from "../icons/PickUpLocationIcon/PickUpLocationIcon";

interface Props {
    schedule: Schedule;
    delivery: DeliveryInGroup;
}

export const InspectorToggleItem: React.FC<Props> = (
    {
        delivery,
    }
) => {
    const pickUpMemo =
        delivery.inProgressAction.type === DeliveryGroupType.PickUp
            ? delivery.inProgressAction.memo
            : delivery.pairAction.memo;
    const dropOffMemo =
        delivery.inProgressAction.type === DeliveryGroupType.DropOff
            ? delivery.inProgressAction.memo
            : delivery.pairAction.memo;

    // const loadFormat = getLoadFormat(delivery);

    const textAreaRef = useRef<HTMLTextAreaElement>(null);

    const handleClickIssueCheckBox = async () => {
        try {
            if (delivery.inProgressAction.issueStatus === IssueStatus.Occur) {
                // await deliveryApi.solvePickUpIssue(detailInfos.deliveryId);
            } else {
                // await deliveryApi.occurPickUpIssue(detailInfos.deliveryId);
            }
            try {
                // const response = await scheduleApi.getById({ scheduleId: schedule.id });
                // dispatch(
                //   updateScheduleInMapAsyncAction({ scheduleDto: response.data })
                // );
            } catch (error) {
                console.log(error);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <OpenBox>
                <ContentContainer>
                    <ContentHeaderContainer>
                        <LoadQuantityBox>
                            {delivery.load.name === "null" || delivery.load.name === ""
                                ? "물품 현장 확인"
                                : delivery.load.name}{" "}
                            {delivery.load.quantity || ""}
                        </LoadQuantityBox>
                        {delivery.inProgressAction.retryCount > 0 && (
                            <RetryLabel>
                                <RecompleteIcon size={16}/>
                                <RetryLabelText>재배송 완료</RetryLabelText>
                            </RetryLabel>
                        )}
                    </ContentHeaderContainer>
                    {/* // TODO  */}
                    <IconContainer>
                        <IconBox>
                            {delivery.inProgressAction.type === DeliveryGroupType.PickUp ? (
                                <DropOffLocationIcon
                                    fill={`${theme.palette.primitives.gray400}`}
                                    width="14px"
                                    height="14px"
                                />
                            ) : (
                                <PickUpLocationIcon
                                    fill={`${theme.palette.primitives.gray400}`}
                                    width="14px"
                                    height="14px"
                                />
                            )}
                            <RequirementContent
                                style={{
                                    color: `${
                                        delivery.pairWorkPlace.alias
                                            ? `${theme.palette.primitives.gray600}`
                                            : `${theme.palette.primitives.gray400}`
                                    }`,
                                }}
                            >
                                {`${delivery.pairWorkPlace.detail} 
                  ${delivery.pairWorkPlace.alias}` ||
                                    (delivery.inProgressAction.type === DeliveryGroupType.PickUp
                                        ? "상차지명이 없습니다."
                                        : "전달지명이 없습니다.")}
                            </RequirementContent>
                        </IconBox>

                        <IconBox>
                            <CommentLineIcon
                                fill={`${theme.palette.primitives.gray400}`}
                                width="14px"
                                height="14px"
                            />
                            <RequirementContent
                                style={{
                                    color: `${
                                        delivery.inProgressAction.requirement
                                            ? `${theme.palette.primitives.gray600}`
                                            : `${theme.palette.primitives.gray400}`
                                    }`,
                                }}
                            >
                                {delivery.inProgressAction.requirement || "요청사항이 없습니다"}
                            </RequirementContent>
                        </IconBox>

                        {pickUpMemo && (
                            <IconBox>
                                <MemoPickUpLineIcon
                                    fill={`${theme.palette.primitives.gray400}`}
                                    width="14px"
                                    height="14px"
                                />
                                <RequirementContent
                                    style={{
                                        color: `${theme.palette.primitives.gray600}`,
                                    }}
                                >
                                    {`[상차 메모] ${pickUpMemo}`}
                                </RequirementContent>
                            </IconBox>
                        )}

                        {dropOffMemo && (
                            <IconBox>
                                <MemoDropOffLineIcon
                                    fill={`${theme.palette.primitives.gray400}`}
                                    width="14px"
                                    height="14px"
                                />
                                <RequirementContent
                                    style={{
                                        color: `${theme.palette.primitives.gray600}`,
                                    }}
                                >
                                    {`[전달 메모] ${dropOffMemo}`}
                                </RequirementContent>
                            </IconBox>
                        )}
                    </IconContainer>

                    {/* {active ? (
        <CustomButton
                        value={toggleValue}
                        onClick={(e: any) => {
                          registerationHandler();
                        }}
                      >
                        수정완료
                      </CustomButton>
        ) : (
        <CustomButton
                        value={toggleValue}
                        onClick={(e: any) => {
                          onClick?.(e);
                          registerationHandler();
                        }}
                      >
                        등록하기
                      </CustomButton>
        )} */}

                    {/* ) : ( */}
                    {/* <TextAreaBox>
                        <CustomTextArea
                          ref={textareaRef}
                          onChange={onChange}
                          placeholder="코멘트를 작성하세요."
                          defaultValue={commentText === null ? "" : commentText}
                        ></CustomTextArea>
                      </TextAreaBox> */}
                    {/* )} */}

                    {/* {registeration ? ( */}
                    {/* <CustomButton
                        value={toggleValue}
                        onClick={(e: any) => {
                          registerationHandler();
                        }}
                      >
                        수정완료
                      </CustomButton> */}
                    {/* ) : ( */}
                    {/* <CustomButton
                        value={toggleValue}
                        onClick={(e: any) => {
                          onClick?.(e);
                          registerationHandler();
                        }}
                      >
                        등록하기
                      </CustomButton> */}
                    {/* )} */}
                </ContentContainer>
            </OpenBox>
        </>
    );
};

const LoadQuantityBox = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */

  /* All/Gray 900 */

  color: #1c2026;
  margin-top: 4px;
  margin-bottom: 12px;
`;

const ClickBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-height: 33px;
`;

const CustomIcon = styled(Icon)`
  position: absolute;
  top: 8px;
  left: 0;
  width: 24px;
  height: 24px;
  padding: 10px 8px;
  margin-right: 2px;
`;

const CustomP = styled.p`
  width: 343px;
  padding: 12px 0px 0px 26px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: #000000;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const OpenBox = styled.div`
  margin: 12px 0 0 26px;
`;

const ContentContainer = styled.div`
  border-bottom: 1px solid ${(props: any) => props.theme.palette.primitives.gray100};
  padding: 4px 0 12px;
`;

const ContentHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const IconBox = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 6px;
  height: 100%;
  /* 
  & svg {
    position: absolute;
    top: 0;
    left: 0;
  } */
`;

const PhoneContent = styled.div`
  margin: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  padding-top: 2px;
  padding-left: 8px;
  height: 100%;
`;

const RequirementContent = styled.div`
  margin: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  // padding-top: 2px;
  padding-left: 8px;
  height: 100%;
`;

const IconContainer = styled.div`
  // & div:last-child {
  // margin-bottom: 12px;
  // }
`;

const TextAreaRegisterationBox = styled.div`
  width: 100%;
  height: 99px;
  font-size: 13px;
  color: #4d535c;
  box-sizing: border-box;
  border: 1px solid ${(props: any) => props.theme.palette.primitives.gray200};
  margin-top: 18px;
  background-color: ${(props: any) => props.theme.palette.primitives.white};
  overflow-y: scroll;
`;

const TextAreaRegisterationContent = styled.p`
  padding: 12px;
  margin: 0;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  color: ${(props: any) => props.theme.palette.primitives.gray600};
`;

const RetryLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  justify-content: center;
`;

const RetryLabelText = styled.div`
  font-size: 13px;
  color: ${theme.palette.primitives.gray400};
  font-weight: 500;
  line-height: normal;
`;
